import { render } from "./LeadForm.vue?vue&type=template&id=44609d24&scoped=true"
import script from "./LeadForm.vue?vue&type=script&lang=js"
export * from "./LeadForm.vue?vue&type=script&lang=js"

import "./LeadForm.vue?vue&type=style&index=0&id=44609d24&lang=postcss&scoped=true"

import exportComponent from "/codebuild/output/src804629530/src/be-admin-portal/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-44609d24"]])

export default __exports__